<template>

<div class="view">

    <app-view-sheet-wrapper 
        :fields="fields"
        :filter="filter"
        :stickyFields="stickyFields" 
        :gridSticky="gridSticky" 
        :grid="grid"
        v-on:scrollleft="onScrollLeft" 
    >

        <template v-slot:sticky v-if="stickyFields.length">

            <app-view-sheet-item 
                :grid="gridSticky" 
                :fields="stickyFields" 
                :filter="filter" 
                :item="item" 
                :can="can"
                :key="item.id" 
                :is-sticky="true"
                v-for="item in data" 
                :sticky-height="height[item.id]"
            />

        </template>

        <app-view-sheet-item 
            :grid="grid" 
            :fields="fields" 
            :filter="filter" 
            :item="item" 
            :can="can"
            :key="item.id" 
            v-for="item in data" 
            v-on:height="onHeightChange(item.id, $event)"
        />

        <slot></slot>

    </app-view-sheet-wrapper>

</div>

</template>

<script>

import $field from '@/field'

export default {

	props: ['data', 'fields', 'filter', 'view', 'can'],

    data: function() {

        return {
            left: 0,
            height: {}
        }

    },

    computed: {

        sticky: function() {

            var sticky = []

            if (this.left) {

                var position = 0
                var stickyWidth = 0
                var stickyLimit = this.window.width / 2

                this.$_.each(this.fields, function(field) {

                    var type = $field.type[field.type]

                    var defaultWidth = type.config.defaultWidth || 0

                    if (this.$_.isObject(defaultWidth)) {

                        if (defaultWidth.list) {

                            defaultWidth = defaultWidth.list

                        } else {

                            defaultWidth = defaultWidth.default

                        }

                    }

                    var width = 0

                    if (type.config.fixedWidth) {

                        width = type.config.fixedWidth

                    } else if (field.width === 'custom') {

                        width = field.customwidth || defaultWidth
                        
                    } else {
                    
                        if(type.config.minWidth) {

                            if (this.$_.isObject(type.config.minWidth)) {

                                if (this.$isDesktop) {

                                    width = type.config.minWidth.desktop

                                } else {

                                    width = type.config.minWidth.mobile

                                }

                            } else {

                                width = type.config.minWidth

                            }

                        } else if(defaultWidth) {

                            width = defaultWidth

                        }

                    }

                    width = parseInt(width)

                    if (position < this.left + stickyWidth && (field.sticky === 1 || field.sticky === 2 && this.window.is.desktop) && stickyWidth < stickyLimit - width) {

                        sticky.push(field.id)

                        stickyWidth += width + 10

                    }

                    position += width + 10

                }.bind(this))

            }

            return sticky

        },

        stickyFields: function() {

            return this.$_.filter(this.fields, function(field) {

                return this.$_.contains(this.sticky, field.id)

            }.bind(this))

        },

        grid: function() {

            var grid = []

            this.$_.each(this.fields, function(field) {

                var type = $field.type[field.type]

                var defaultWidth = type.config.defaultWidth || 0

                if (this.$_.isObject(defaultWidth)) {

                    if (defaultWidth.sheet) {

                        defaultWidth = defaultWidth.sheet

                    } else {

                        defaultWidth = defaultWidth.default

                    }

                }

                if (type.config.fixedWidth) {

                    grid.push(type.config.fixedWidth + 'px')

                } else if (field.width === 'custom') {

                    grid.push((field.customwidth || defaultWidth) + 'px')
                    
                } else {
                
                    if(type.config.minWidth) {

                        if (this.$_.isObject(type.config.minWidth)) {

                            if (this.$isDesktop) {

                                grid.push('minmax(' + type.config.minWidth.desktop + 'px, 1fr)')

                            } else {

                                grid.push('minmax(' + type.config.minWidth.mobile + 'px, 1fr)')

                            }

                        } else {

                            grid.push('minmax(' + type.config.minWidth + 'px, 1fr)')

                        }

                    } else if(defaultWidth) {

                        grid.push(defaultWidth + 'px')

                    } else {

                        grid.push('minmax(120px, 1fr)')

                    }

                }

            }.bind(this))

            return grid.join(' ')

        },

        gridSticky: function() {

            var grid = []

            this.$_.each(this.stickyFields, function(field) {

                var type = $field.type[field.type]

                var defaultWidth = type.config.defaultWidth || 0

                if (this.$_.isObject(defaultWidth)) {

                    if (defaultWidth.sheet) {

                        defaultWidth = defaultWidth.sheet

                    } else {

                        defaultWidth = defaultWidth.default

                    }

                }

                if (type.config.fixedWidth) {

                    grid.push(type.config.fixedWidth + 'px')

                } else if (field.width === 'custom') {

                    grid.push((field.customwidth || defaultWidth) + 'px')
                    
                } else {
                
                    if(type.config.minWidth) {

                        if (this.$_.isObject(type.config.minWidth)) {

                            if (this.$isDesktop) {

                                grid.push(type.config.minWidth.desktop + 'px')

                            } else {

                                grid.push(type.config.minWidth.mobile + 'px')

                            }

                        } else {

                            grid.push(type.config.minWidth + 'px')

                        }

                    } else if(defaultWidth) {

                        grid.push(defaultWidth + 'px')

                    } else {

                        grid.push('120px')

                    }

                }

            }.bind(this))

            return grid.join(' ')

        }

    },

    methods: {

        onHeightChange: function(id, value) {

            this.height[id] = value

        },

        onScrollLeft: function(value) {

            this.left = value

        }

    }

}

</script>

<style scoped>

.is-desktop .view {
    max-height: calc(100vh - 64px);
    overflow: hidden;
    display: grid;
    grid-template-rows: 32px 1fr;
}

</style>